"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var image_1 = require("../models/image");
var PreviewDirection;
(function (PreviewDirection) {
    PreviewDirection[PreviewDirection["ROW"] = 0] = "ROW";
    PreviewDirection[PreviewDirection["COLUMN"] = 1] = "COLUMN";
})(PreviewDirection = exports.PreviewDirection || (exports.PreviewDirection = {}));
var ImagePreviews = /** @class */ (function (_super) {
    __extends(ImagePreviews, _super);
    function ImagePreviews() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderImages = function (images, imageIndex) {
            var imagePreviews = images.map(function (image, idx) {
                var selected = idx === imageIndex;
                var className = "ma-preview";
                if (selected) {
                    className = "ma-preview selected";
                }
                return (react_1.default.createElement("a", { href: "#", className: "ma-preview-link", key: image.shopifyImageId, onClick: function (ev) { return _this.showImage(ev, idx); } },
                    react_1.default.createElement("img", { src: image.mainURL, key: image.shopifyImageId, className: className, srcSet: image_1.sourceSetString(image.mainURL, image.srcSet) })));
            });
            var isVertical = _this.props.direction === PreviewDirection.COLUMN;
            var directionName = isVertical ? "ma-vertical" : "ma-horizontal";
            return (react_1.default.createElement("div", { className: "ma-image-previews-container " + directionName },
                react_1.default.createElement("div", { className: "ma-image-previews" }, imagePreviews)));
        };
        _this.renderNoImages = function () {
            return react_1.default.createElement("div", { className: "ma-no-image-previews" });
        };
        _this.showImage = function (ev, index) {
            ev.preventDefault();
            _this.props.showImageAtIndex(index);
        };
        return _this;
    }
    ImagePreviews.prototype.render = function () {
        var _a = this.props, images = _a.images, imageIndex = _a.imageIndex;
        return images.length <= 1 ?
            this.renderNoImages()
            : this.renderImages(images, imageIndex);
    };
    return ImagePreviews;
}(react_1.default.PureComponent));
exports.ImagePreviews = ImagePreviews;
